import { cloneElement, isValidElement, useId, type ReactElement, type ReactNode } from 'react';
import { clsx } from 'clsx';

/** Lightweight CSS tooltip — shows on hover / keyboard focus (desktop).
 *  On touch devices the wrapped control's aria-label covers accessibility. */
export function Tooltip({
  label,
  children,
  side = 'top',
  className,
}: {
  label: string;
  children: ReactNode;
  side?: 'top' | 'bottom';
  className?: string;
}) {
  const id = useId();
  const child = isValidElement(children)
    ? cloneElement(children as ReactElement<{ 'aria-describedby'?: string }>, {
        'aria-describedby': id,
      })
    : children;
  return (
    <span className={clsx('group/tt relative inline-flex', className)}>
      {child}
      <span
        id={id}
        role="tooltip"
        className={clsx(
          'pointer-events-none absolute left-1/2 z-50 -translate-x-1/2 whitespace-nowrap rounded-none bg-ink/95 px-2.5 py-1 text-[11px] font-semibold text-surface opacity-0 shadow-float transition-opacity duration-150 group-hover/tt:opacity-100 group-focus-within/tt:opacity-100',
          side === 'top' ? 'bottom-full mb-1.5' : 'top-full mt-1.5',
        )}
      >
        {label}
      </span>
    </span>
  );
}
